import React from 'react';
import PropTypes from 'prop-types';

export const BoothLightboxContext = React.createContext({
  url: null,
  setUrl: null,
  onClose: null,
  streamId: null,
  setCfStreamId: null,
});

const BoothLightboxContextProvider = ({ children }) => {
  const [videoURL, setVideoURL] = React.useState(null);
  const [cfStreamId, setCfStreamId] = React.useState(null);

  const onClose = () => {
    setVideoURL(null);
    setCfStreamId(null);
  };

  return (
    <BoothLightboxContext.Provider
      value={{
        url: videoURL,
        cfStreamId,
        setCfStreamId,
        setUrl: (url) => setVideoURL(url),
        onClose,
      }}
    >
      {children}
    </BoothLightboxContext.Provider>
  );
};

BoothLightboxContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BoothLightboxContextProvider;
